import initSlider from '../libs/initSlider';
import { tabsContentSliderOptions } from '../sliders/sliders';
import { tabsSliderOptions } from '../sliders/sliders';

document.addEventListener('DOMContentLoaded', (e) => {
  const accordions = document.querySelectorAll('[data-faq-card]');

  accordions.forEach((item) => {
    const title = item.querySelector('[data-faq-card-title]');
    title.addEventListener('click', () => item.classList.toggle('is_opened'));
  });

  /*  */

  const infrastructureTabsSlider = initSlider('[data-infrastructure-tabs-slider]', tabsSliderOptions);
  const infrastructureSlider = initSlider('[data-infrastructure-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: infrastructureTabsSlider,
      autoScrollOffset: 0.5,
    },
  });
});
